import React from 'react';

import ProductsList from '@/components/Pages/Home/ProductsList';

function CompanyPageContent() {
  return <ProductsList />;
}

export default CompanyPageContent;
